
export const roomNoFormatter = (roomNo:string) => {
  return roomNo ? parseInt(roomNo.slice(roomNo.length - 4)) : roomNo;
};
